import React from 'react';
import { css } from 'glamor';
import { FLAVOUR_COLOURS } from './constants/flavourColours';

const wrapper = css({ display: 'inline-flex', alignItems: 'center', gap: 6, whiteSpace: 'nowrap' });

export const StateDot = ({ flavour = 'gray', children }) => (
	<span className={wrapper}>
		<span className={css({ width: 8, height: 8, borderRadius: 4, flexShrink: 0, background: FLAVOUR_COLOURS[flavour] ?? FLAVOUR_COLOURS.gray })} />
		<span>{children}</span>
	</span>
);
